import chakraTokenToVar from '@/utils/chakraTokenToVar'
import { FONT_FAMILY } from '@/constants/constants'

export default {
  baseStyle: {
    fontFamily: FONT_FAMILY.default,
    fontWeight: 600,
    border: 'none',
    bg: 'none',
    px: '24px',
    py: '9px',
    borderRadius: '8px',
    textDecoration: 'none',
    _hover: {
      cursor: 'pointer',
    },
    _disabled: {
      cursor: 'not-allowed !important',
    },
  },
  variants: {
    solid: {
      minW: 120,
      backgroundColor: 'primary.solid',
      color: 'primary.contrast',
      _hover: {
        backgroundColor: 'primary.emphasized',
      },
      _active: {
        backgroundColor: 'primary.emphasized',
      },
      _disabled: {
        color: 'fg.subtle',
        backgroundColor: 'bg.emphasized',
      },
    },
    outline: {
      minW: 120,
      backgroundColor: 'bg',
      border: '2px solid',
      borderColor: 'border',
      color: 'primary.fg',
      _hover: {
        backgroundColor: 'bg.subtle',
      },
      _active: {
        backgroundColor: 'bg.muted',
      },
      _disabled: {
        color: 'fg.subtle',
      },
    },
    'outline-selected': {
      minW: 120,
      backgroundColor: 'primary.subtle',
      border: '2px solid',
      borderColor: 'border',
      color: 'primary.fg',
      _hover: {
        backgroundColor: 'primary.muted',
      },
      _active: {
        backgroundColor: 'primary.emphasized',
      },
      _disabled: {
        color: 'fg.subtle',
      },
    },
    'dark-gray-small': {
      minW: 120,
      backgroundColor: 'gray.500',
      color: 'gray.contrast',
      fontSize: '14px',
      borderRadius: '16px',
      height: '32px',
      _hover: {
        backgroundColor: 'gray.600',
      },
      _active: {
        backgroundColor: 'gray.700',
      },
    },
    ghost: {
      p: 0,
      borderColor: 'border',
      color: 'primary.fg',
      borderRadius: 0,
      border: 'none',
      _hover: {
        bg: 'none',
        color: 'primary.emphasized',
      },
      _active: {
        bg: 'none',
        color: 'primary.emphasized',
      },
      _disabled: {
        color: 'fg.subtle',
        bg: 'none',
      },
    },
    danger: {
      minW: 120,
      backgroundColor: 'error.solid',
      color: 'error.contrast',
      _hover: {
        backgroundColor: 'error.solid',
      },
      _active: {
        backgroundColor: 'error.solid',
      },
      _disabled: {
        backgroundColor: 'bg.emphasized',
        color: 'fg.subtle',
      },
    },

    'danger-outline': {
      minW: 120,
      backgroundColor: 'bg',
      border: '2px solid',
      borderColor: 'border',
      color: 'error.fg',
      _hover: {
        backgroundColor: 'bg.subtle',
      },
      _active: {
        backgroundColor: 'bg.muted',
      },
      _disabled: {
        color: 'fg.subtle',
      },
    },
    accent: {
      minW: 120,
      backgroundColor: 'warning.solid',
      color: 'warning.contrast',
      _hover: {
        backgroundColor: 'warning.solid',
      },
      _active: {
        backgroundColor: 'warning.solid',
      },
      _focus: {
        outline: 'none',
        boxShadow: `0 0 3px ${chakraTokenToVar('warning.focusRing')}`,
      },
      _disabled: {
        backgroundColor: 'bg.emphasized',
        color: 'fg.subtle',
      },
    },
    icon: {
      color: 'fg.muted',
      fontSize: '16px',
      width: '32px',
      minW: '32px',
      height: '32px',
      _hover: {
        backgroundColor: 'bg.muted',
      },
      _active: {
        backgroundColor: 'bg.emphasized',
      },
    },
    'icon-outline': {
      backgroundColor: 'bg',
      border: '2px solid',
      color: 'primary.fg',
      borderColor: 'border',
      _hover: {
        backgroundColor: 'bg.subtle',
      },
      _active: {
        backgroundColor: 'bg.muted',
      },
      _disabled: {
        color: 'fg.subtle',
      },
    },
    white: {
      minW: 120,
      backgroundColor: 'bg',
      color: 'fg',
      _hover: {
        backgroundColor: 'bg.muted',
      },
      _active: {
        backgroundColor: 'bg.emphasized',
      },
    },
    'link-btn': {
      p: 0,
      color: 'primary.solid',
      borderRadius: 0,
      border: 'none',
      height: 'auto',
      textDecoration: 'underline',
      _hover: {
        bg: 'none',
        color: 'primary.emphasized',
      },
      _active: {
        bg: 'none',
        color: 'primary.emphasized',
      },
      _disabled: {
        color: 'fg.subtle',
        bg: 'none',
      },
    },
  },
  defaultProps: {
    variant: 'solid',
  },
}
